import { render } from "./UploadForm.vue?vue&type=template&id=71763c67"
import script from "./UploadForm.vue?vue&type=script&lang=js"
export * from "./UploadForm.vue?vue&type=script&lang=js"

import "./UploadForm.vue?vue&type=style&index=0&id=71763c67&lang=css"
script.render = render

export default script